/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface ListSuppliesSimple$Params {
  CompanyId?: string;
  filter?: string;
}

export function listSuppliesSimple(http: HttpClient, rootUrl: string, params?: ListSuppliesSimple$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, listSuppliesSimple.PATH, 'get');
  if (params) {
    rb.query('CompanyId', params.CompanyId, {});
    rb.query('filter', params.filter, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

listSuppliesSimple.PATH = '/api/gmn/Supply/listsuppliessimple';
